import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Collapse,
  Flex,
  Link,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { memo } from 'react';
import { BiLink } from 'react-icons/bi';
import { IAttachmentProps } from '../../../../../services/hooks/CandidateArea/useRequestMyExemption';
import TitleSectionMobilePage from '../../../../../components/Mobile/titleSection';
import LabelWithValueMobilePage from '../../../../../components/Mobile/labelWithValue';

interface IOwnProps {
  isOpen: boolean;
  dataToExemption: IMoreDetail;
}

interface IMoreDetail {
  observation?: string;
  justification?: string;
  status?: string;
  attachments?: IAttachmentProps[];
}

const MoreDetailExemptionMobilePage: React.FC<IOwnProps> = ({ isOpen, dataToExemption }) => {
  const seeMore = useDisclosure();

  const observation = dataToExemption?.observation || '';

  return (
    <Collapse in={isOpen} animateOpacity>
      <Accordion mt={3} allowMultiple>
        <AccordionItem border="1px solid" borderColor="gray.400" borderRadius="md" overflow="hidden">
          <AccordionButton
            sx={{ WebkitTapHighlightColor: 'transparent' }}
            _hover={{ bg: 'transparent' }}
            background="white"
            color="black"
          >
            <Text fontWeight="semibold" as="span" flex="1" textAlign="left">
              Dados da solicitação
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={2} pt={0}>
            {dataToExemption?.observation && (
              <Box>
                <Text mt="-1px" lineHeight="tall">
                  {(observation.length > 200 && (
                    <>
                      {observation.substring(0, seeMore.isOpen ? observation.length : 200)}
                      {seeMore.isOpen ? '' : '...'}
                      <Text
                        whiteSpace="nowrap"
                        as="span"
                        onClick={seeMore.onToggle}
                        cursor="pointer"
                        fontSize="small"
                        ml={1}
                        color="blue.400"
                      >
                        ver {seeMore.isOpen ? 'menos' : 'mais'}
                      </Text>
                    </>
                  )) ||
                    observation}
                </Text>
              </Box>
            )}
            {dataToExemption?.attachments && (
              <Stack m={0} p={0} gap={0} mt={2} ml={2} pb={2}>
                <TitleSectionMobilePage>Documentos anexados</TitleSectionMobilePage>
                {!dataToExemption?.attachments && <Text>Sem Anexos</Text>}
                <UnorderedList p={0} ml={2}>
                  {dataToExemption?.attachments?.map((attach, index) => (
                    <ListItem listStyleType="''" key={index} p={0} m={0}>
                      <Flex color="colorLink" gap={1} align="center">
                        <Box>
                          <BiLink />
                        </Box>
                        <Link target="_blank" href={attach.file}>
                          <Text fontSize="0.8rem">
                            Anexo {index + 1}{' '}
                            <Text fontSize="0.6rem" color="black" as="span">
                              ({attach.created_at || ''})
                            </Text>
                          </Text>
                        </Link>
                      </Flex>
                    </ListItem>
                  ))}
                </UnorderedList>
              </Stack>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
      <Box mt={4}>
        <VStack align="start" fontSize="x-small" spacing={0}>
          <Text pr={4} pb={1} mb={2} fontWeight="bold" borderBottom="1px solid" borderColor="gray.200">
            Resposta da análise de isenção
          </Text>
          <Stack gap={0.5} ml={2}>
            <LabelWithValueMobilePage label="Situação" value={dataToExemption?.status} />
            {dataToExemption?.justification && (
              <LabelWithValueMobilePage
                label="Justificativa da análise"
                value={dataToExemption?.justification}
                acceptTag
              />
            )}
          </Stack>
        </VStack>
      </Box>
    </Collapse>
  );
};

export default memo(MoreDetailExemptionMobilePage);
